import type { Program } from '../api/useGetPrograms';

export type ProgramStatus = 'Upcoming' | 'Live' | 'Past' | 'Expired';

export const programStatus = (p: Pick<Program, 'active' | 'starts_at' | 'ends_at'>): ProgramStatus => {
  const now = Date.now();
  if (p.ends_at && new Date(p.ends_at).getTime() < now) return 'Past';
  if (p.starts_at && new Date(p.starts_at).getTime() > now) return 'Upcoming';
  return p.active ? 'Live' : 'Expired';
};
